/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _8 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>8 - Дополнительные материалы</h2>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        <a
          className={styles.link}
          target="_blank"
          rel="noopener noreferrer"
          href="https://youtu.be/1h9_cB9mPT8?list=PLqGj3iMvMa4LFz8DZ0t-89twnelpT4Ilw"
        >
          GitHub for Noobs by DevTips
        </a>
      </li>
      <li className={styles.list__item}>
        <a
          className={styles.link}
          href="https://youtu.be/GyI0T2U_vO8?list=PLpY_9m7gHQDibfa9MJfnEQd2UWI5gztp8"
          target="_blank"
          rel="noopener noreferrer"
        >
          Видеокурс по работе с Git из консоли
        </a>
      </li>
      <li className={styles.list__item}>
        <a
          className={styles.link}
          href="https://github.com/progit/progit/blob/master/ru/02-git-basics/01-chapter2.markdown"
          target="_blank"
          rel="noopener noreferrer"
        >
          Хороший учебник по основам git
        </a>
      </li>
      <li className={styles.list__item}>
        <a
          className={styles.link}
          href="https://www.atlassian.com/git/tutorials/what-is-version-control"
          target="_blank"
          rel="noopener noreferrer"
        >
          Книга по Git от atlassian.com
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://git-scm.com/book/ru/v2" target="_blank" rel="noopener noreferrer">
          Официальная документация/книга по Git
        </a>
      </li>
    </ul>
  </section>
))
